<template>
    <div :class="['frame_popup', align]" style="z-index: 9999">
        <iframe :src="frameSrc"
            style="width: 100%; height: 100%;"></iframe>
        <div class="close_btn">
            <a href="#" class="close" @click.prevent="closeThisWin()">닫기</a>
        </div>
    </div>
</template>

<script>

export default {
    props: {
        align: {
            type: String,
            default: 'right',
        },
        frameSrc: {
            type: String,
            require: true,
        },
    },
    methods: {
        closeThisWin(){
            this.$eventBus.$emit('FrameWin::close-win');
        },
    },
};
</script>
